<div class="card w-full h-full flex flex-col shadow-sm p-8 rounded-2xl bg-white gap-8">
  <div class="flex flex-row justify-between">
    <div class="flex flex-col">
      <h1 class="font-semibold text-2xl">
        Diseños
      </h1>
    </div>
  </div>
  <div class="flex flex-row flex-wrap justify-start gap-4">
    <app-custom-input [(value)]="color" placeholder="Buscar colores..." (enter)="findAll(true)">
    </app-custom-input>
    <app-button label="Buscar" (click)="findAll(true)"></app-button>
    <app-button label="Limpiar filtros" color="red-500" icon="fi-rr-eraser" (click)="cleanFilter()"></app-button>
  </div>
  <div class="overflow-x-auto">

    @if (colorList && colorList.length > 0) {
    <div class="card">
      <p-table
        [value]="colorList"
        [paginator]="true"
        [rows]="rows"
        [first]="first"
        [lazy]="true"
        [lazyLoadOnInit]="false"
        (onLazyLoad)="loadColors($event)"
        [totalRecords]="totalItems"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
        [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '50rem' }"
        >
        <ng-template #header>
          <tr>
            <th pSortableColumn="id" class="px-4 py-2 text-left font-semibold text-base gap-2">
              <div class="flex items-center gap-2">
                ID
                <p-sortIcon field="id" />
              </div>
            </th>
            <th pSortableColumn="name" class="px-4 py-2 text-left font-semibold text-base gap-2">
              <div class="flex items-center gap-2">
                Nombre
                <p-sortIcon field="name" />
              </div>
            </th>
            <th class="px-4 py-2 text-left font-semibold text-base gap-2">
              <div class="flex items-center gap-2">
                Imágen
              </div>
            </th>
            <th pSortableColumn="active" class="px-4 py-2 font-semibold text-base text-center">
              <div class="flex items-center justify-center gap-2">
                Activo
                <p-sortIcon field="active" />
              </div>
            </th>
            <th class="px-4 py-2 text-left font-semibold text-base gap-2 text-center">
              <div class="flex items-center justify-center gap-2">
                Acción
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-colorList>
          <tr class="hover:bg-orange-50">
            <td class="px-6 py-4">{{ colorList.id }}</td>
            <td class="px-6 py-4">{{ colorList.name }}</td>
            <td class="px-6 py-4">
              @if (colorList.url) {
                <div style="width:64px; height:64px; display:flex; align-items:center; justify-content:center;">
                  <img
                    [src]="colorList.url"
                    alt="Imagen"
                    width="64"
                    height="64"
                    style="object-fit:cover; border-radius:12px; box-shadow:0 2px 8px #0001; border:2px solid #fff;"
                  />
                </div>
              } @else {
                <div style="width:64px; height:64px; display:flex; align-items:center; justify-content:center; background:#f3f3f3; border-radius:12px; color:#bbb; font-size:24px; border:2px solid #fff;">
                  <i class="fi fi-rr-picture"></i>
                </div>
              }
            </td>
            <td class="px-6 py-4">
              <div class="flex justify-center">
                <span
                  class="inline-flex px-3 py-1 text-xs font-medium rounded-xl"
                  [ngClass]="getBackgroundClasses(colorList.active)">
                  {{ colorList.active ? 'Activo' : 'Inactivo' }}
                </span>
              </div>
            </td>
            <td class="px-6 py-4">
              <div class="text-gray-400 flex flex-row gap-1 justify-center">
                <i class="fi fi-rr-pencil flex text-2xl text-blue-300 cursor-pointer hover:text-blue-700"
                  title="Editar" (click)="openEditModal(colorList.id)"></i>
                  
                @if (colorList.active) {
                  <i class="fi fi-rr-toggle-on flex text-2xl text-green-500 cursor-pointer hover:text-green-700"
                     title="Desactivar" 
                     (click)="openActivateColorModal(colorList.name, colorList.id)"></i>
                } @else {
                  <i class="fi fi-rr-toggle-off flex text-2xl text-gray-400 cursor-pointer hover:text-gray-600"
                     title="Activar" 
                     (click)="openActivateColorModal(colorList.name, colorList.id, true)"></i>
                }
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    } @else {
    <div class="bg-yellow-100 p-4 rounded-2xl">
      No hay registros
    </div>
    }
  </div>
</div>
